<template>
    <AppHeader fixed>
        <SidebarToggler class="d-lg-none" display="md" mobile />
        <b-link class="navbar-brand" to="#">
            <img class="navbar-brand-full" :src="$dynamicLogo.path || $logoPath" height="40" alt="PUI Logo">
            <img class="navbar-brand-minimized" :src="$dynamicLogo.path || 'img/brand/sygnet.svg'" width="30" height="30" alt="PUI Logo">
        </b-link>
        <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
        <Breadcrumb id="pgiBreadCrumb" class="header-breadcrumb d-md-down-none" :list="list" />
        <!-- <div class="ml-2 header-user-cabang">
			<span class="mb-0">Cabang</span>
			<strong> Daan Mogot </strong>
		</div> -->
        <!-- <b-navbar-nav class="d-md-down-none">
			<b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
		</b-navbar-nav> -->
        <b-navbar-nav class="ml-auto">
            <b-nav-item class="d-md-down-none">
                <CabangOption className="header-small-dropdown" />
            </b-nav-item>
            <b-nav-item @click="openNotif">
                <button type="button" class="header-icon-btn">
                    <i class="fa fa-bell"></i>
                    <b-badge v-if="totalNotif > 0" pill variant="danger" class="header-notif-badge">
                        {{ totalNotif}}
                    </b-badge>
                </button>
            </b-nav-item>
            <b-nav-item>
                <div class="header-user-info">
                    <b-dropdown variant="light" toggle-class="header-user-avatar" no-caret left>
                        <template v-slot:button-content>
                            {{ initials }}
                        </template>
                        <b-dropdown-item @click="$bvModal.show('modal-change-password')">
                            <i class="fa fa-cog mr-2 text-primary"></i>Ubah Password
                        </b-dropdown-item>
                        <b-dropdown-item @click="logout">
                            <i class="fa fa-power-off text-primary mr-2" /><span>Log Out</span>
                        </b-dropdown-item>
                    </b-dropdown>
                    <div class="header-user-text">
                        <h6 class="header-user-name">{{ name }}</h6>
                        <span class="header-user-position">{{ role }}</span>
                    </div>
                </div>
            </b-nav-item>

            <ModalConfirm id="modal-confirm-logout" title="Confirm Logout" :isSubmitting="isSubmitting"
                desc="Apakah anda yakin untuk logout?" @submit="onSubmit" />
        </b-navbar-nav>
        <b-modal id="modal-change-password" title="Ubah Password" no-close-on-esc no-close-on-backdrop
            :hide-header-close="isSubmitting">
            <b-form id="changePasswordForm" @submit.prevent="openModalConfirmChangePwd">
                <div class="modal-form-wrapper">
                    <b-form-group label="Password Lama" class="password-form-group">
                        <b-form-input v-model="input.oldPassword" name="oldPassword" :type="oldPasswordType"
                            required></b-form-input>
                        <i :class="oldIconName" @click="changePasswordType(1)"></i>
                    </b-form-group>
                    <b-form-group label="Password Baru" class="password-form-group">
                        <b-form-input v-model="input.newPassword" name="newPassword" :type="newPasswordType" minlength=6
                            required></b-form-input>
                        <i :class="newIconName" @click="changePasswordType(2)"></i>
                    </b-form-group>
                    <b-form-group label="Ketik Ulang Password Baru" class="password-form-group">
                        <b-form-input v-model="input.confirmPassword" name="confirmPassword" :type="confirmPasswordType"
                            minlength=6 required></b-form-input>
                        <i :class="confirmIconName" @click="changePasswordType(3)"></i>
                    </b-form-group>
                </div>
                <!-- <div class="login-error-wrapper mt-3" v-if="errorMessage != ''">
                    <div class="text-danger">{{ errorMessage }}</div>
                </div> -->
            </b-form>
            <template v-slot:modal-footer>
                <b-button variant="pgiBtn" name="changePasswordBtn" type="submit" form="changePasswordForm"
                    :disabled="isSubmitting">
                    {{ isSubmitting ? "Mengubah..." : "Ubah Password" }}
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="modal-confirm-editPwd" title="Confirm Change Password" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk mengubah password anda?" @submit="doChangePassword" />
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import CabangOption from '../components/cabang/CabangOption'
import Breadcrumb from './CustomBreadcrumb'

export default {
    name: 'DefaultHeader',
    components: {
        AsideToggler,
        AppHeader,
        // DefaultHeaderDropdownAccnt,
        SidebarToggler,
        CabangOption,
        Breadcrumb
    },
    props: {
        // hasNotification: { type: Boolean, required: true }
        totalNotif: { type: Number, required: true },
        list: { type: Array, default: () => [] }
    },
    data() {
        return {
            isSubmitting: false,
            name: localStorage.getItem("name"),
            role: localStorage.getItem("role"),
            cabang: localStorage.getItem("activeCabang"),
            input: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            errorMessage: "",

            oldPasswordType: 'password',
            oldIconName: 'fa fa-eye-slash',
            newPasswordType: 'password',
            newIconName: 'fa fa-eye-slash',
            confirmPasswordType: 'password',
            confirmIconName: 'fa fa-eye-slash',
        }
    },
    computed: {
        initials() {
            if (!this.name) return ''
            let parts = this.name.trim().split(/\s+/)
            if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
        }
    },
    methods: {
        logout() {
            this.$bvModal.show("modal-confirm-logout")
        },
        onSubmit() {
            this.$emit("did-logout")
        },
        openNotif() {
            this.$emit("did-tap-notification")
            this.$router.push("/dashboard")
        },

        doChangePassword() {

            let payload = new FormData()
            payload.append("oldPassword", this.input.oldPassword)
            payload.append("newPassword", this.input.newPassword)
            payload.append("repeatNewPassword", this.input.confirmPassword)

            this.isSubmitting = true
            this.$axios.post("user/selfChangePassword/", payload).then(response => {

                this.input.oldPassword = ""
                this.input.newPassword = ""
                this.input.confirmPassword = ""
                this.oldPasswordType = 'password'
                this.oldIconName = 'fa fa-eye-slash'
                this.newPasswordType = 'password'
                this.newIconName = 'fa fa-eye-slash'
                this.confirmPasswordType = 'password'
                this.confirmIconName = 'fa fa-eye-slash'
                this.$helper.toastSucc(this, "Password berhasil diubah, silahkan login kembali!")
                this.$bvModal.hide("modal-confirm-editPwd")
                this.$bvModal.hide("modal-change-password")
            })
                .catch(error => {
                    // this.$helper.parseError(this, error)
                    // this.errorMessage = error.response.data.reason
                    this.$helper.toastErr(this, error.response.data.reason)
                    this.$bvModal.hide("modal-confirm-editPwd")

                })
                .finally(() => {
                    this.isSubmitting = false
                })

        },
        //----------------- Fungsi Lain -----------------

        openModalConfirmChangePwd() {
            this.$bvModal.show("modal-confirm-editPwd")
        },

        changePasswordType(id) {
            if (id == 1) {
                if (this.oldPasswordType == 'password' && this.oldIconName == 'fa fa-eye-slash') {
                    this.oldPasswordType = 'text'
                    this.oldIconName = 'fa fa-eye'
                }
                else {
                    this.oldPasswordType = 'password'
                    this.oldIconName = 'fa fa-eye-slash'
                }
            } else if (id == 2) {
                if (this.newPasswordType == 'password' && this.newIconName == 'fa fa-eye-slash') {
                    this.newPasswordType = 'text'
                    this.newIconName = 'fa fa-eye'
                }
                else {
                    this.newPasswordType = 'password'
                    this.newIconName = 'fa fa-eye-slash'
                }
            } else {
                if (this.confirmPasswordType == 'password' && this.confirmIconName == 'fa fa-eye-slash') {
                    this.confirmPasswordType = 'text'
                    this.confirmIconName = 'fa fa-eye'
                }
                else {
                    this.confirmPasswordType = 'password'
                    this.confirmIconName = 'fa fa-eye-slash'
                }
            }
        },
    }
}
</script>
